import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Tooltip } from 'antd';
import { useDrag, useDrop } from 'react-dnd';
import classnames from 'classnames';

import { FILE_LIST_TYPE } from 'constants/products';

const DragableUploadListItem = ({
  intl,
  originNode,
  moveRow,
  file,
  fileList,
  itemFooterLabel,
  itemFooterLabelIndex
}) => {
  const [showFooterLabel, setShowFooterLabel] = useState(false);

  const ref = useRef(null);
  const index = fileList.indexOf(file);

  useEffect(() => {
    if (
      itemFooterLabel &&
      !isNaN(itemFooterLabelIndex) &&
      index === itemFooterLabelIndex
    ) {
      setShowFooterLabel(true);
    } else {
      setShowFooterLabel(false);
    }
  }, [index]);

  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: FILE_LIST_TYPE,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};

      if (dragIndex === index) {
        return {};
      }

      return {
        isOver: monitor.isOver(),
        dropClassName: `ant-upload__draggable-list-item-dragging__${
          dragIndex > index ? 'left' : 'right'
        }`
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    }
  });
  const [collected, drag] = useDrag({
    type: FILE_LIST_TYPE,
    item: {
      index
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });
  drop(drag(ref));
  const errorNode = (
    <Tooltip
      title={intl.formatMessage({
        id: 'products.add_products.product_details.image_field.upload_error'
      })}
    >
      {originNode.props.children}
    </Tooltip>
  );
  return (
    <div
      className={classnames(
        `ant-upload__draggable-list-item ${isOver ? dropClassName : ''}`,
        {
          'ant-upload__draggable-list-item-dragging': collected?.isDragging
        }
      )}
      ref={ref}
    >
      {file.status === 'error' ? errorNode : originNode}
      {showFooterLabel && (
        <div className="br-ant-upload__draggable-list-item__footer caption-medium">
          {itemFooterLabel}
        </div>
      )}
    </div>
  );
};

export default injectIntl(DragableUploadListItem);
